/**
* This is a TypeGen auto-generated file.
* Any changes made to this file will be lost when the file is regenerated.
*/

import {Observable} from "rxjs";
import {Injectable, Injector} from "@angular/core";
import {HttpEvent} from "@angular/common/http";
import {ApiServiceBase} from "../../api-service-base";
import {DeleteRequest} from "../model/delete-request";
import {ListData} from "../model/list-data";
import {PowerDistributionUnit} from "../model/power-distribution-unit";
import {SuccessResponse} from "../model/success-response";
import {UpdateAllPowerDistributionUnitsRequest} from "../model/update-all-power-distribution-units-request";
import {UpsertPowerDistributionUnitRequest} from "../model/upsert-power-distribution-unit-request";

@Injectable({
    providedIn: "root",
})
export class SimPowerDistributionUnitService extends ApiServiceBase {
	constructor(injector: Injector) {
        super(injector);
	}
    public deletePowerDistributionUnit(request: DeleteRequest) {
        return super.post<SuccessResponse>(`/api/PowerDistributionUnit/DeletePowerDistributionUnit`, request);
    }

    public getPowerDistributionUnits(searchTerm: string = null, searchColumn: string = "name", sortColumn: string = "name", sortAscending: boolean = true, page: number = 0, pageSize: number = 2147483647) {
        return super.get<ListData<PowerDistributionUnit>>(`/api/PowerDistributionUnit/GetPowerDistributionUnits`, {searchTerm: searchTerm, searchColumn: searchColumn, sortColumn: sortColumn, sortAscending: sortAscending, page: page, pageSize: pageSize});
    }

    public powerOffPowerDistributionUnit(powerDistributionUnitId: string) {
        return super.get<SuccessResponse>(`/api/PowerDistributionUnit/PowerOffPowerDistributionUnit`, {powerDistributionUnitId: powerDistributionUnitId});
    }

    public powerOnPowerDistributionUnit(powerDistributionUnitId: string) {
        return super.get<SuccessResponse>(`/api/PowerDistributionUnit/PowerOnPowerDistributionUnit`, {powerDistributionUnitId: powerDistributionUnitId});
    }

    public updateAllPowerDistributionUnits(request: UpdateAllPowerDistributionUnitsRequest) {
        return super.post<boolean>(`/api/PowerDistributionUnit/UpdateAllPowerDistributionUnits`, request);
    }

    public upsertPowerDistributionUnit(request: UpsertPowerDistributionUnitRequest) {
        return super.post<SuccessResponse>(`/api/PowerDistributionUnit/UpsertPowerDistributionUnit`, request);
    }
}